/** @format */

import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useEffect } from "react";
import AboutForm from "./about/about-form";
import SocialLinksForm from "./about/social-links-form";
import BasicInfoForm from "./about/basic-info-form";
import Experience from "./experience/experience";
import Education from "./education/education";
import SkillsForm from "./skills/skills-form";
import CertLicenses from "./certs_licenses/cert_licenses";
import Resume from "./resume/resume";
import MyProfileMultipleForm from "./about/form-wizard";
import Skill from "./skills/skills";

const MyProfile = () => {
  // Extract hash from the URL
  const hash = window.location.hash.replace("#", "") || "about";

  const handleSelect = (key) => {
    window.location.hash = key; // Update URL hash on tab change
  };

  useEffect(() => {
    const handleHashChange = () => {
      // Update tab selection based on URL hash
      const hash = window.location.hash.replace("#", "");
      if (hash) {
        document.querySelector(`#${hash}-tab`)?.click();
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  return (
    <Card>
      <Card.Body>
        <Row>
          <Tab.Container
            defaultActiveKey={hash}
            onSelect={handleSelect} // Update URL hash on tab change
          >
            <Col sm="3">
              <Nav
                as="ul"
                variant="pills"
                className="flex-column text-left"
                id="v-pills-tab"
                aria-orientation="vertical"
              >
                <Nav.Link
                  eventKey="about"
                  id="about-tab"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected={hash === "about"}
                >
                  About
                </Nav.Link>
                <Nav.Link
                  eventKey="experience"
                  id="experience-tab"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected={hash === "experience"}
                >
                  Experiences
                </Nav.Link>
                <Nav.Link
                  eventKey="education"
                  id="education-tab"
                  role="tab"
                  aria-controls="v-pills-messages"
                  aria-selected={hash === "education"}
                >
                  Education
                </Nav.Link>
                <Nav.Link
                  eventKey="skills"
                  id="skills-tab"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected={hash === "skills"}
                >
                  Skills
                </Nav.Link>
                <Nav.Link
                  eventKey="certs_licenses"
                  id="certs_licenses-tab"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected={hash === "certs_licenses"}
                >
                  Certs or Licenses
                </Nav.Link>
                <Nav.Link
                  eventKey="resume"
                  id="resume-tab"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected={hash === "resume"}
                >
                  Resume
                </Nav.Link>
              </Nav>
            </Col>
            <Col sm="9">
              <Tab.Content className="mt-0" id="v-pills-tabContent">
                <Tab.Pane
                  eventKey="about"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="about-tab"
                >
                  <MyProfileMultipleForm />
                </Tab.Pane>
                <Tab.Pane
                  eventKey="experience"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="experience-tab"
                >
                  <Experience />
                </Tab.Pane>
                <Tab.Pane
                  eventKey="education"
                  id="v-pills-messages"
                  role="tabpanel"
                  aria-labelledby="education-tab"
                >
                  <Education />
                </Tab.Pane>
                <Tab.Pane
                  eventKey="skills"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="skills-tab"
                >
                  <Skill />
                </Tab.Pane>
                <Tab.Pane
                  eventKey="certs_licenses"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="certs_licenses-tab"
                >
                  <CertLicenses />
                </Tab.Pane>
                <Tab.Pane
                  eventKey="resume"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="resume-tab"
                >
                  <Resume />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Tab.Container>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MyProfile;
